import Autocomplete from './Autocomplete';
import LocationAutocomplete from './LocationAutocomplete';

export { LocationAutocomplete };
export default Autocomplete;

